<template>
  <div>
    <b-tabs card pills>
      <b-tab :title="$t('Settings')">
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

        <basic-table
            v-if="voluntarySuspensionSettings"
            :items="voluntarySuspensionSettings"
            :fields="fields"
            @ClickOnDeleteButton="ClickOnDeleteButton"
            @ClickOnEditButton="editItem"
            :filter="filter"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            isDelete="true"
            isEdit="true"/>
        <table-manager-bottom
            :totalRows="totalRows" :perPage="perPage"
            v-model="currentPage"/>
      </b-tab>
      <b-tab :title="$t('Blocks')">
        <allSuspensions/>
      </b-tab>
    </b-tabs>

    <editModal :editItem="selectedVoluntarySuspensionSetting"/>
  </div>
</template>

<script>
import editModal from './editModal'
import allSuspensions from './allSuspensions'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedVoluntarySuspensionSetting: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  components: {
    editModal,
    allSuspensions
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Voluntary suspension setting?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_VOLUNTARY_SUSPENSION_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_VOLUNTARY_SUSPENSION_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedVoluntarySuspensionSetting = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditVoluntarySuspensionSettings', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedVoluntarySuspensionSetting = {
        group_id: 0,
        id: 0,
        is_enabled: 0,
        priority: 0,
        block_type: 0,
        free_balance: 0.0,
        interval_duration: 0,
        max_duration: 0,
        min_balance: 0.0,
        min_duration: 0,
        self_unlock: 0,
        service_id: 0,
        use_free_balance: 0,
        use_min_balance: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditVoluntarySuspensionSettings', '#btnShow')
    }
  },
  computed: {
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    voluntarySuspensionSettings () {
      return this.$store.getters['Settings/VOLUNTARY_SUSPENSION_SETTINGS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_VOLUNTARY_SUSPENSION_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/voluntarySuspension/main.vue